import { actions } from '.';

export function getRepositoriesSucceed(payload) {
  return {
    type: actions.GET_REPOSITORIES_SUCCEED,
    payload
  };
}

export function getRepositoriesFailure(payload) {
  return {
    type: actions.GET_REPOSITORIES_FAILURE,
    payload
  };
}

export function createRepositoriesSucceed(payload) {
  return {
    type: actions.CREATE_REPOSITORIES_SUCCEED,
    payload
  };
}

export function updateRepositorySucceed(payload) {
  return {
    type: actions.UPDATE_REPOSITORY_SUCCEED,
    payload
  };
}

export function deleteRepositorySucceed(payload) {
  return {
    type: actions.DELETE_REPOSITORY_SUCCEED,
    payload
  };
}
